









import { Vue, Component, Prop } from 'vue-property-decorator';
import FullCalendar, { FullCalendarComponent } from '@fullcalendar/vue';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin, { TimeGridView } from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import listPlugin from '@fullcalendar/list';

// eslint-disable-next-line @typescript-eslint/no-var-requires
const jaLocale = require('@fullcalendar/core/locales/ja'); // 日本語化用

@Component({ components: { FullCalendar } })
export default class TestPage extends Vue {
  public calendarPlugins = [timeGridPlugin, dayGridPlugin, interactionPlugin, listPlugin];
  get timeZone() {
    return 'Asia/Tokyo';
    // :timeZone="timeZone"
  }
  get calendarEventsModel() {
    console.log(new Date('2021-05-15 16:00:00').toISOString());
    return [
      {
        title: 'test',
        start: new Date('2021-05-15 16:00:00'),
        end: new Date('2021-05-15 17:00:00'),
        id: '1',
      },
    ];
  }
  get locale() {
    return jaLocale;
  }
}
